// Linhas do card "Pastas (CT / FT / OC)" do preview. O backend devolve só as linhas
// de Local Arquivo que já existem; o Provisionar cria as que faltam. Sem cruzar com
// a lista fixa, um par com CT/FT (onboarding do embarcador antigo) escondia a OC.
export const TIPOS_PASTA = ["CT", "FT", "OC"];

export function linhasPastas(linhas) {
  const lista = Array.isArray(linhas) ? linhas : [];
  return TIPOS_PASTA.map((tipo) => {
    const doTipo = lista.filter((l) => l && l.tipo === tipo);
    const ativa = doTipo.find((l) => Number(l.status) === 1);
    if (ativa) return { tipo, situacao: "ativa", rotulo: "ativa" };
    if (doTipo.length) return { tipo, situacao: "desligada", rotulo: "desligada → será religada" };
    return { tipo, situacao: "criar", rotulo: "será criada" };
  });
}
